import React from 'react';
import { UserApplicationRole } from '../../constants';
import {
  ApolloClientsProvider,
  ApolloClientsProviderProps,
} from '../ApolloClientsProvider';
import { AuthContext } from '../AuthContext';
import { AuthTokenProvider } from '../AuthTokenContext';
import { ConfigContext } from '../ConfigContext';
import { RoleGuardProvider } from '../RoleGuardContext';

export const GlobalContext: React.FC<GlobalContextProps> = ({
  children,
  clientSpecifiers,
  requiredRoles = [],
}) => (
  <ConfigContext.Provider>
    <AuthContext>
      <AuthTokenProvider>
        <ApolloClientsProvider clientSpecifiers={clientSpecifiers}>
          <RoleGuardProvider requiredRoles={requiredRoles}>
            {children}
          </RoleGuardProvider>
        </ApolloClientsProvider>
      </AuthTokenProvider>
    </AuthContext>
  </ConfigContext.Provider>
);

export interface GlobalContextProps extends ApolloClientsProviderProps {
  requiredRoles?: UserApplicationRole[];
}
